"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _automationHooks = require("@airportlabs/automation-hooks");
var FieldParts = _interopRequireWildcard(require("./FieldParts"));
var _index = require("../index");
var _helpers = require("../helpers");
var _base = require("../themes/_base");
var _excluded = ["children", "label", "labelVariant", "error", "info", "variant", "containerProps", "automationHook"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var propTypes = {
  /** A description for the entire group, the legend for the fieldset. When not
   * invisible it's displayed above the radio buttons. */
  label: _propTypes["default"].string.isRequired,
  /** The styling of the legend. By default it will be `visible`. In order to
   * keep the field accessible in cases where you do not want to display the
   * label, please include a label text and select "invisible" variant for it */
  labelVariant: _propTypes["default"].oneOf(["visible", "invisible"]),
  /** Child elements to be displayed inside the wrapper. Not applicable for RadioGroupFormik.  */
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  /** Description that appears under the field, explaining what it does */
  info: _propTypes["default"].string,
  /** Error Text - displayed under the field */
  error: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].bool]),
  /** Wether or not the element should have a margin bottom */
  mB: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string]),
  /** Buttons Wrapper props:
   *
   * Choose the layout of the radio buttons. Default value is "flex" and outputs
   * a Flex container. All props related to this container type are supported.
   * The "grid" variant supports 2 extra props  minSize/maxSize  */
  variant: _propTypes["default"].oneOf(["flex", "grid"]),
  /**
   * Props to pass to the Buttons Wrapper
   * supports flex container props and if variant is grid, also supports
   * minSize/maxSize which it will use to do grid-columns-template
   */
  containerProps: _propTypes["default"].shape({
    gap: _propTypes["default"].oneOf(_base.spaceTypes),
    gapV: _propTypes["default"].oneOf(_base.spaceTypes),
    justifyContent: _propTypes["default"].oneOf(["flex-start", "flex-end", "center"]),
    alignItems: _propTypes["default"].oneOf(["flex-start", "flex-end", "center"]),
    minSize: _propTypes["default"].string,
    maxSize: _propTypes["default"].string
  }),
  /** Hook used for automation testing */
  automationHook: _propTypes["default"].string,
  /** DEPRECATED: Margin bottom for the field wrapper */
  marginBottom: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string])
};
exports.propTypes = propTypes;
var ButtonsWrapper = (0, _styledComponents["default"])(_index.Box).attrs(function (props) {
  return {
    gap: props.gap || "s",
    wrap: props.wrap || "wrap"
  };
}).withConfig({
  displayName: "RadioButtonGroup__ButtonsWrapper",
  componentId: "sc-1wueif4-0"
})(["display:flex;", ""], function (props) {
  return props.variant === "grid" && (0, _styledComponents.css)(["display:grid;grid-gap:", ";grid-template-columns:repeat( auto-fit,minmax( ", ",", " ) );"], function (props) {
    return (0, _helpers.getSpace)(props, "gap", "s");
  }, function (props) {
    return props.minSize || "70px";
  }, function (props) {
    return props.maxSize || "1fr";
  });
});
var RadioButtonGroup = function RadioButtonGroup(_ref) {
  var children = _ref.children,
    label = _ref.label,
    labelVariant = _ref.labelVariant,
    error = _ref.error,
    info = _ref.info,
    variant = _ref.variant,
    containerProps = _ref.containerProps,
    automationHook = _ref.automationHook,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(FieldParts.GroupWrapper, rest, /*#__PURE__*/_react["default"].createElement(FieldParts.Legend, _extends({
    hasError: !!error,
    variant: labelVariant
  }, (0, _automationHooks.hook)(automationHook, "field-label")), label), /*#__PURE__*/_react["default"].createElement(ButtonsWrapper, _extends({
    variant: variant
  }, containerProps), children), info && /*#__PURE__*/_react["default"].createElement(FieldParts.Info, (0, _automationHooks.hook)(automationHook, "field-info"), info), error && /*#__PURE__*/_react["default"].createElement(FieldParts.Error, (0, _automationHooks.hook)(automationHook, "field-error"), error));
};
RadioButtonGroup.propTypes = propTypes;
var _default = RadioButtonGroup;
exports["default"] = _default;